<template>
	<section id="temas">
		<Notification ref="notif" :closed="true" corner="bottom-right" />
		<load-content v-if="loadContent" />
		<div v-if="temas.length > 0">
			<form @submit.prevent>
				<container textButton="voltar" :pathName="path" :pathIcone="true">
					<div class="search-section">
						<input type="text" @keyup="(e) => buscar(e)" placeholder="Pesquisar por tema">
						<label for="search"><i class="fas fa-search"></i></label>
					</div>
					<div class="publicacoes">
						<label for="todos" class="todos">
							<input type="checkbox" id="todos" v-model="selectAll" />
								Selecionar todos
						</label>
						<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
						<div v-if="temas.length > 0" v-for="tema in temas" :key="tema.id" >
							<label :for="tema.id">
								<input type="checkbox" @click="(e) => formataObjeto(e)" :id="tema.id" :value="tema.id" v-model="selecionados">
									{{tema.titulo}}
							</label>
						</div>
					</div>
					<div class="submit-form">
						<button-submit class="large" type="button" :onClick="publicar" :disabled="loadingSubmit">
							PUBLICAR
						</button-submit>
					</div>
				</container>
			</form>
		</div>
		<div v-else class="objectNotFound">
				Nenhum tema encontrado :)
		</div>
	</section>
</template>
<script>
import { tipos } from '@/services/tipos'
import container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'
import ButtonSubmit from '@/components/shared/ButtonAction'
import { objetos } from '@/services/objetos'
export default {
	name: 'TemasList',
	components: {
		container, ButtonSubmit, LoadContent
	},
	data () {
		return {
			loadingSubmit: false,
			loadContent: false,
			temas: [],
			selecionados: [],
			temasBackup: [],
			form: {
				temas: []
			}
		}
	},
	async created () {
		this.loadContent = true
		const tipo = {
			nome: 'Tema'
		}
		const retornoTipo = await tipos.find(tipo)
		const temas = await objetos.find({ tipos: retornoTipo.data[0].id, teste: 2000 })
		this.temas = this.temasBackup = temas.data
		this.loadContent = false
	},
	methods: {
		buscar (e) {
			const condition = new RegExp(e.target.value.toLowerCase())
			const retorno = this.temasBackup.filter(function (el) {
				return condition.test(el.titulo.toLowerCase())
			})
			this.temas = retorno
		},
		async publicar () {
			if (this.form.temas.length > 0) {
				this.submitted = true
				this.loadingSubmit = true
				await objetos.publish(this.form.temas)
				window.notificationEM.open('', 'Publicação acionada com sucesso, isto pode demorar um pouco!', 'success')
				this.loadingSubmit = false
				this.selecionados = []
				this.form.temas = []
			}
			// student id 2854459
			// ALESSANDRA LOPES OLIVEIRA
		},
		formataObjeto (e) {
			const tema = this.form.temas.findIndex(tema => tema.id === e.target.value)
			const selecionado = this.selecionados.findIndex(s => s === e.target.value)

			if (tema !== -1) {
				this.form.temas = this.form.temas.filter(tema => tema.id !== e.target.value)
			} else {
				const temaObject = this.temas.filter(tema => tema.id === e.target.value)
				this.form.temas.push({
					id: temaObject[0].id,
					urlObjeto: temaObject[0].urlObjeto
				})
			}
			if (selecionado !== -1) {
				this.selecionado = this.selecionados.splice(selecionado, 1)
			} else {
				this.selecionados.push(e.target.value)
			}
		}
	},
	computed: {
		selectAll: {
			get () {
				return this.temas ? this.temas.length === this.form.temas : false
			},
			set (value) {
				this.form.temas = []
				this.selecionados = []
				if (value) {
					this.temas.map(tema => {
						this.form.temas.push({
							id: tema.id,
							urlObjeto: tema.urlObjeto
						})
						this.selecionados.push(tema.id)
					})
				}
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.path
		})
	}
}
</script>
<style lang="scss" scoped>
#temas {
	.search-section {
		border: 1px solid #f2f2f2;
		input {
			padding: 0px 10px 0px 0px;
		}
	}
	.publicacoes {
		max-height: 400px;
		overflow: auto;
		label {
			color: #000;
		}
		.todos {
			display: inline-block;
			font-weight: bold;
			margin: 5px 0 10px 0;
		}
	}
}

::-webkit-scrollbar {
    width: 12px;
}
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  outline: 1px solid slategrey;
}
</style>
